import type { ServiceProvider as BaseServiceProvider } from '@takeshape/service-providers';
import type { ServiceProvider, ServiceProviderUI } from '../types.js';

export const serviceProviderUiDefaults: ServiceProviderUI = {
  experimental: false,
  requiresOAuthFlow: false,
  hasIntrospectableSchema: false,
  avatarPath: '',
  logoPath: ''
};

export function createServiceProvider(base: BaseServiceProvider & Partial<ServiceProviderUI>): ServiceProvider {
  return {
    ...serviceProviderUiDefaults,
    hasIntrospectableSchema: Boolean(base.introspectionType),
    ...base
  };
}
